// src/pages/UserRentalPoliciesPage.js
import React, { useEffect, useState } from 'react';
import api from '../api';
import './UserRentalPoliciesPage.css';
import ReactMarkdown from 'react-markdown';

const UserRentalPoliciesPage = () => {
    const [policy, setPolicy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        api.get('/store/rental-policy')
            .then(({ data }) => setPolicy(data))
            .catch(() => setError('Unable to load rental policies.'))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <p>Loading...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;
    if (!policy) return null;

    return (
        <div className="rental-policy-page">
            <h1>Rental Policies</h1>
            <div className="rental-protection-policy">
                <h1>Rental Protection Policy</h1>
                {policy.policyDescription ? <ReactMarkdown>{policy.policyDescription}</ReactMarkdown> : (
                    <>
                        <h2>Lost / Damaged / Stolen</h2>
                        <p>You are liable for repair or replacement cost. Rental‑Protection Coverage limits liability to
                            the deductible displayed at checkout.</p>
                    </>
                )}
            </div>

            <div className="rental-agreement-policy">
                <h1>Rental Agreement</h1>
                {policy.rentalAgreement ? <ReactMarkdown>{policy.rentalAgreement}</ReactMarkdown> : (
                    <>
                        <h2>Late Returns</h2>
                        <p>A late fee equal to one full rental day is charged for every calendar day past return
                            date.</p>
                    </>
                )}
            </div>

        </div>
    );
};
export default UserRentalPoliciesPage;